document.addEventListener('DOMContentLoaded', function() {
  var modal = document.getElementById("yotpo-tos-modal");
  var pageLink = document.getElementById("yotpo-tos-link");
  var popupLink = document.getElementById("popup_yotpo-tos-link");
  var closeBtn = document.getElementsByClassName("yotpo-close")[0];

  function openModal() {
    modal.style.display = "block";
  }

  function closeModal() {
    modal.style.display = "none";
  }

  if (pageLink) {pageLink.addEventListener("click", openModal)}
  if (popupLink) {popupLink.addEventListener("click", openModal)}
  closeBtn.addEventListener("click", closeModal);
  window.addEventListener("click", function (event) {
    if (event.target == modal) {
      closeModal();
    }
  });
})

// Yotpo and subscribed to email newsletters by default
function loyaltyOption() {
  var registerFormBtn = document.querySelector("#register-form-btn");

  if (registerFormBtn) {
    registerFormBtn.addEventListener("click", function (e) {
      localStorage.setItem("LoyaltyOptIn", true);
      sessionStorage.setItem("LoyaltyOptIn", true);
    });
  }
};

document.addEventListener("DOMContentLoaded", () => {
  loyaltyOption();
});